import React, { useEffect, useState } from 'react';
import styles from './ModelAlarm.module.css';
import close from 'assets/close.png';
import { useSearchParams } from 'react-router-dom';
import proxy from 'proxy';
import { getUsers } from '../../../../../../redux/slices/organizationSlice.js';
import { useDispatch, useSelector } from 'react-redux';

const ModelAlarm = ({
  setOpenModel,
  setInputValue,
  alarm,
  titleText,
  setNewAlarm,
  setChatId,
  setBotToken,
  selectedTriggerType,
  setSelectedTriggerType,
  checklist,
  selectedChecklist,
  setSelectedChecklist,
}) => {
  const [selectedOption, setSelectedOption] = useState(); // State to store selected medium value
  const [openOptionModel, setOpenOptionModel] = useState(false); // State to handle telegram option model
  const [threshold, setThreshold] = useState(); // State to store threshold value
  const [thresholdUnit, setThresholdUnit] = useState(); // State to store threshold unit
  const [alarmType, setAlarmType] = useState(
    alarm.alarmType ? alarm.alarmType : 'normal',
  );
  // const [compareChannel, setCompareChannel] = useState(
  //   alarm?.compareChannel ? alarm.compareChannel : '',
  // ); // State to store compare channel name

  const [selectedEmail, setSelectedEmail] = useState(
    alarm.email || alarm.toEmail || '',
  );
  const [selectedChannel, setSelectedChannel] = useState(alarm.channel || '');

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showChannelModal, setShowChannelModal] = useState(false);

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const projectID = searchParams.get('project');

  const [memberList, setMemberList] = useState([]);

  const [compareChannel, setCompareChannel] = useState(
    alarm?.compareChannel || '',
  );

  const [channelNames, setChannelNames] = useState([]);

  const organizationEmail = localStorage.getItem('organizationEmail');
  const userEmail = localStorage.getItem('email');

  const orgMembers = useSelector(
    (state) => state.organization?.orgMembers || [],
  );

  useEffect(() => {
    dispatch(
      getUsers({
        userEmail,
        organizationEmail,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setMemberList(orgMembers);
  }, [orgMembers]);

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(
          `${proxy}/api/projectChannelList?projectId=${projectID}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );

        const result = await response.json();

        if (Array.isArray(result.data)) {
          setChannelNames(result.data);
        } else {
          setChannelNames([]);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (projectID) {
      fetchChannels();
    }
  }, [projectID]);

  // Updating the state on page load
  useEffect(() => {
    if (alarm.medium) {
      setSelectedOption(alarm.medium);
    }

    if (alarm.triggerType) {
      setSelectedTriggerType(
        alarm.triggerType ? alarm.triggerType : 'onTrigger',
      );
    }

    if (alarm.threshold) {
      const unit = alarm.threshold.at(alarm.threshold.length - 1);
      const value = alarm.threshold.slice(0, alarm.threshold.length - 1);

      setThresholdUnit(unit);

      setThreshold(value);
    } else {
      setThresholdUnit('m');
      setThreshold(2);
    }

    if (alarm.checklist) {
      setSelectedChecklist(alarm.checklist);
    }
  }, []);

  // Function to store selected media option
  const handleOptions = (e) => {
    setSelectedOption(e.target.value);
  };

  // To open Telegram Model
  const handleOptionModel = () => {
    if (selectedOption === 'telegram') {
      setOpenOptionModel(true);
    } else {
      setOpenOptionModel(false);
    }
  };

  // Function for closing model
  const handleCloseModel = () => {
    setOpenModel(false);
  };

  // Function to handle saving new values
  const handleSaveModel = () => {
    setOpenModel(false);
    const modifiedValues = {
      alarmName: document.getElementById('alarmNameInput').value,
      alarmId: alarm.alarmId,
      projectId: alarm.projectId,
      // channel: document.getElementById('channelNameInput').value,
      channel: selectedChannel,
      toEmail: selectedEmail,
      value: document.getElementById('valueInput').value,
      alarmType: document.getElementById('alarmType').value,
      operation: document.getElementById('operationOption')?.value || '=',
      medium: selectedOption,
      triggerType: selectedTriggerType,
      triggerValue: alarm.triggerValue ? alarm.triggerValue : false,
      threshold: threshold.toString() + thresholdUnit,
      timehit: alarm?.timehit ?? null,
      compareChannel: alarmType === 'deviation' ? compareChannel : null,
      checklist: selectedChecklist ?? null,
    };

    console.log("modifiedValues:", modifiedValues);

    if (!alarm.alarmId) {
      setNewAlarm(modifiedValues);
    } else {
      setInputValue(modifiedValues);
    }
  };

  return (
    <div className={styles.modelAlarm}>
      <div className={styles.inputWrapper}>
        <div className={styles.closeBtnWrapper}>
          <h2 className={styles.titleText}>{titleText}</h2>
          <button className={styles.closeBtn} onClick={handleCloseModel}>
            <img src={close} alt="Close" className={styles.closePng} />
          </button>
        </div>
        <input
          className={styles.alarmNameInput}
          id="alarmNameInput"
          type="text"
          placeholder="Alarm Name"
          defaultValue={alarm.alarmName}
        />

        {/* <input
          className={styles.channelNameInput}
          type="text"
          id="channelNameInput"
          placeholder="Channel Name (Case Sensitive)"
          defaultValue={alarm.channel}
        /> */}
        <select
          className={styles.selectOptions}
          value={selectedChannel}
          onChange={(e) => setSelectedChannel(e.target.value)}
        >
          <option value="">Select Channel</option>

          {channelNames.map((channel, index) => (
            <option key={index} value={channel}>
              {channel}
            </option>
          ))}
        </select>

        <div className={styles.alarmType}>
          <label htmlFor="alarmType" className={styles.labelOptions}>
            Alarm Type :
          </label>
          <select
            className={styles.selectOptions}
            id="alarmType"
            defaultValue={alarm.alarmType}
            onChange={(e) => setAlarmType(e.target.value)}
          >
            <option value="normal">Normal Alarm</option>
            <option value="offline">Offline Channel Alarm</option>
            <option value="deviation">Deviation Alarm</option>
            <option value="rateOfChange">Rate Of Change</option>
          </select>
        </div>

        {/* {alarmType === 'deviation' && (
          <input
            type="text"
            placeholder="Enter Compare Channelname(Case Sensitive)"
            onChange={(e) => setCompareChannel(e.target.value)}
            className={styles.valueInput}
            defaultValue={compareChannel}
          />
        )} */}
        {alarmType === 'deviation' && (
          <div className={styles.alarmType}>
            <label className={styles.labelOptions}>Compare Channel :</label>

            <select
              className={styles.selectOptions}
              value={compareChannel}
              onChange={(e) => setCompareChannel(e.target.value)}
            >
              <option value="">Select Compare Channel</option>

              {channelNames.map((channel, index) => (
                <option key={index} value={channel}>
                  {channel}
                </option>
              ))}
            </select>
          </div>
        )}

        <input
          className={styles.valueInput}
          type="text"
          id="valueInput"
          placeholder="Alarm Value"
          defaultValue={alarm.value}
        />
        {/* {alarmType === "normal" && ( */}

        <div className={styles.functionOptions}>
          <label htmlFor="functionOptions" className={styles.labelOptions}>
            Function :
          </label>
          <select className={styles.selectOptions} id="operationOption">
            <option selected disabled hidden>
              {alarm.operation}
            </option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
            <option value="=">=</option>
          </select>
        </div>
        {/*  */}

        <div className={styles.alarmType}>
          <div className={styles.alarmTypeWrapper}>
            <label htmlFor="Trigger Alarm Type" className={styles.labelOptions}>
              Trigger Alarm Type :
            </label>
            <select
              className={styles.selectOptions}
              id="triggerAlarm"
              value={selectedTriggerType}
              onChange={(e) => setSelectedTriggerType(e.target.value)}
            >
              <option value="onTrigger">On Trigger</option>
              <option value="offTrigger">Off Trigger</option>
              <option value="betweenTrigger">Between Trigger</option>
              <option value="afterTrigger">After Trigger</option>
            </select>
          </div>
        </div>

        <div className={styles.mediaOptions}>
          <label htmlFor="functionOptions" className={styles.labelOptions}>
            Notification Media :
          </label>
          <select
            id="mediaOption"
            onClick={handleOptionModel}
            value={selectedOption}
            onChange={handleOptions}
            className={styles.selectOptions}
          >
            <option value="whatsapp">WhatsApp</option>
            <option value="email">Email</option>
            <option value="telegram">Telegram</option>
            <option value="sms">SMS</option>
          </select>
          {/* For Open Telegram Model */}
          {openOptionModel ? (
            <>
              <div className={styles.telegramModel}>
                <input
                  className={styles.botTokenInput}
                  id="botToken"
                  type="text"
                  placeholder="Bot Token"
                  onChange={(e) => setBotToken(e.target.value)}
                />
                <input
                  className={styles.chatIdInput}
                  type="text"
                  id="chatid"
                  placeholder="Chat Id"
                  onChange={(e) => setChatId(e.target.value)}
                />
              </div>
            </>
          ) : (
            ''
          )}
        </div>

        <div className={styles.alarmType}>
          <label className={styles.labelOptions}>Threshold:</label>

          <input
            type="number"
            className={styles.valueInput}
            placeholder="Threshold Value"
            onChange={(e) => setThreshold(e.target.value)}
            value={threshold}
          />
          <select
            className={styles.selectOptions}
            onChange={(e) => setThresholdUnit(e.target.value)}
            value={thresholdUnit}
          >
            <option value="h">hour</option>
            <option value="m">minute</option>
            <option value="s">second</option>
          </select>
        </div>

        {selectedOption === 'email' && (
          <div className={styles.alarmType}>
            <label className={styles.labelOptions}>Email</label>

            <select
              className={styles.selectOptions}
              value={selectedEmail}
              onChange={(e) => setSelectedEmail(e.target.value)}
            >
              <option value="">Select Email</option>

              {memberList.map((member, index) => (
                <option key={index} value={member.email}>
                  {member.email}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className={styles.alarmType}>
          <label className={styles.labelOptions}>Checklist:</label>

          <select
            className={styles.selectOptions}
            onChange={(e) => setSelectedChecklist(e.target.value)}
          >
            <option> Select Checklist </option>
            {checklist?.map((val) => (
              <option value={val?.name}>{val?.name}</option>
            ))}
          </select>
        </div>
        <div className={styles.saveModel}>
          <button onClick={handleSaveModel} className={styles.saveBtn}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModelAlarm;
